module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/footer/footer.component.scss
// module id = ./src/app/modules/footer/footer.component.scss
// module chunks = main